import React from "react";
import PropTypes from "prop-types";

function ProviderTrainingBanner({
  lockApplicationFeatures = false,
  trainingUrl = "",
}) {
  if (!lockApplicationFeatures) return null;
  return (
    <div
      className="alert alert-error margin-bottom-0 text-center training-navigation"
      role="alert"
    >
      <label className="form-label padding-left-5 padding-right-5 body-2">
        Please complete training before submitting any applications.
      </label>
      <a
        className="btn training-navigation-btn"
        target="_blank"
        rel="noreferrer"
        href={trainingUrl}
      >
        Begin Training
      </a>
    </div>
  );
}

ProviderTrainingBanner.propTypes = {
  lockApplicationFeatures: PropTypes.bool,
  trainingUrl: PropTypes.string,
};

export default ProviderTrainingBanner;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');